import { useEffect } from 'react';

const FOCUSABLE_SELECTOR =
   'button:not([disabled]):not([hidden]), [href]:not([hidden]), input:not([disabled]):not([hidden]), select:not([disabled]):not([hidden]), textarea:not([disabled]):not([hidden]), [tabindex]:not([tabindex="-1"]):not([hidden])';

export const useFocusTrap = (isActive: boolean, ref: React.RefObject<HTMLElement | null>, autoFocus: boolean = true) => {
   useEffect(() => {
      const node = ref.current;
      if (!isActive || !node) return;

      const previouslyFocused = document.activeElement as HTMLElement | null;

      const getFocusables = () => node.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR);

      if (autoFocus) {
         getFocusables()[0]?.focus();
      } else {
         node.focus({ preventScroll: true });
      }

      const handleKeyDown = (event: KeyboardEvent) => {
         if (event.key !== 'Tab') return;

         const focusables = getFocusables();
         if (focusables.length === 0) return;

         const first = focusables[0];
         const last = focusables[focusables.length - 1];

         if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
         } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
         }
      };

      node.addEventListener('keydown', handleKeyDown);
      return () => {
         node.removeEventListener('keydown', handleKeyDown);
         previouslyFocused?.focus();
      };
   }, [isActive, ref, autoFocus]);
};
